import Api from '../../Api';

/**
 * Stiahne PDF faktúry priamo (direct=true => application/pdf), spracuje ho ako
 * buffer a otvorí v novom okne (alebo ponúkne na stiahnutie) cez blob URL.
 */
export const downloadInvoicePdf = async (appSpace, invoiceNr) => {
  const response = await Api.getInvoicePdfByNr(appSpace, invoiceNr, {
    $queryParameters: { direct: true },
  });
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const win = window.open(url, '_blank');
  if (!win) {
    // popup zablokovaný => fallback na stiahnutie
    const a = document.createElement('a');
    a.href = url;
    a.download = `${invoiceNr}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  // uvoľníme blob URL až po tom, ako stihne načítať nové okno
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
};

/**
 * Celková suma faktúry - súčet cien položiek vrátane DPH.
 */
export const getInvoiceTotal = invoice => {
  const items = (invoice && invoice.items) || [];
  return items.reduce(
    (sum, item) => sum + (item.totalPrice ? item.totalPrice.amount : 0),
    0,
  );
};

/**
 * Suma "K úhrade" - súčet cien položiek vrátane DPH znížený o už uhradené
 * platby (item.payments). Teda zostatok, ktorý ešte treba uhradiť.
 */
export const getInvoiceAmountToPay = invoice => {
  const items = (invoice && invoice.items) || [];
  return items.reduce((sum, item) => {
    const itemTotal = item.totalPrice ? item.totalPrice.amount : 0;
    const paid = (item.payments || []).reduce(
      (p, payment) => p + (payment.amount || 0),
      0,
    );
    return sum + itemTotal - paid;
  }, 0);
};
